"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bubble = void 0;
var _basketUpdated = require("@ori-events/basket-updated");
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _types = require("../../types");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function ignoreClickEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
const Bubble = ({
  code,
  image,
  methodType,
  name,
  points,
  price,
  quantity,
  frequency = 0
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    BUY_FOR_MONEY,
    BUY_FOR_POINTS
  } = _basketUpdated.LastAddedItemMethod;
  const frequencyInWeeks = frequency % 7 === 0 ? frequency / 7 : 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BubbleWrapper, {
    "data-testid": getTestId(_types.TestId.Popup),
    onClick: ignoreClickEvent,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
      component: _styles.ImageWrapper,
      src: image || 'noImage',
      alt: name,
      background: theme.palette.grey[100],
      width: "80px",
      height: "80px"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Details, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
        children: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Shade, {
        children: frequencyInWeeks === 0 ? code : `${code} · ${formatMessage('everyXWeeks', {
          frequencyInWeeks
        })}`
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Shopping, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Quantity, {
          children: [formatMessage('quantity'), ": ", quantity]
        }), methodType === BUY_FOR_MONEY && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Price, {
          children: price
        }), methodType === BUY_FOR_POINTS && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Points, {
          children: points
        })]
      })]
    })]
  });
};
exports.Bubble = Bubble;